module.exports = __webpack_public_path__ + "293abfe730cc746448941371bb5b7cf9.png";